"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var form_constants_1 = require("../../form-constants");
var required_definition_1 = require("./required-definition");
exports.defaultValues = __assign({}, required_definition_1.defaultValues, { type: form_constants_1.requireType.SOME, requiredSubElementsList: immutable_1.List([]) });
exports.SomeRequiredDefinitionRecord = immutable_1.Record(exports.defaultValues);
/** immutable object used to represent the SOME required definition for group elements in the redux store */
var ImmutableSomeRequiredDefinition = /** @class */ (function (_super) {
    __extends(ImmutableSomeRequiredDefinition, _super);
    function ImmutableSomeRequiredDefinition(props) {
        var _this = _super.call(this, __assign({}, props, { requiredSubElementsList: immutable_1.List(props.requiredSubElements) })) || this;
        _this.requiredSubElements = props.requiredSubElements;
        return _this;
    }
    /**
     * creates a clone of the current ImmutableSomeRequiredDefinition
     * @param key property to change
     * @param value value that the property will be set to
     */
    ImmutableSomeRequiredDefinition.prototype.set = function (key, value) {
        var result = _super.prototype.set.call(this, key, value);
        var object = result.toObject();
        return new ImmutableSomeRequiredDefinition(object);
    };
    /** makes sure that converting this to an object includes the requiredSubElements array */
    ImmutableSomeRequiredDefinition.prototype.toObject = function () {
        var object = _super.prototype.toObject.call(this);
        object.requiredSubElements = object.requiredSubElementsList.toArray();
        return object;
    };
    return ImmutableSomeRequiredDefinition;
}(exports.SomeRequiredDefinitionRecord));
exports.ImmutableSomeRequiredDefinition = ImmutableSomeRequiredDefinition;
//# sourceMappingURL=some-required.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-elements/required-definition/some-required.js
// module id = 1135
// module chunks = 0